import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MapHelperService } from "../../../../../../services/map-helper.service";
import { LayerDTO } from "../../../models/LayerDTO";
import { filter, Observable, Subscription, take } from "rxjs";
import { LocationCategoryDTO } from "../../../models/LocationCategoryDTO";
import { PanelInternalLayerService } from "../../../services/Panel-Internal-Layer.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { ToolCarsSelectorService } from "../../../services/Tool-Cars-Selector.service";
import { LayerService } from "../../../services/Layers.service";
import { EnumLayerTypes } from "src/app/features/shared/helpers/enums/EnumLayerTypes";
import { EnumLayerSources } from "src/app/features/shared/helpers/enums/EnumLayerSources";
@Component({
  selector: "panel-internal-layers",
  templateUrl: "./panel-internal-layers.component.html",
  styleUrls: ["./panel-internal-layers.component.css"],
  animations: [
    trigger("mostrarLista", [
      state("visible", style({ opacity: 1, height: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("300ms ease-in-out")),
    ]),
    trigger("expandCollapseLayers", [
      state("expanded", style({ opacity: 1, height: "*" })),
      state("collapsed", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("expanded <=> collapsed", animate("300ms ease-in-out")),
    ]),
  ],
})
export class PanelInternalLayersComponent implements OnInit, OnDestroy {
  isInitializingLayers: boolean = false;

  listaCapasVisible: boolean = false;
  hasVirtualCategories: boolean = false;
  hasGPSCategories: boolean = true;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  //Array con las posibles opcciones.
  //Si se ocupa hacerlo dinámico con los add-ons después, se puede
  $capas = new Array<LayerDTO>();
  suscription_GetListLayers: Subscription;
  suscription_GetLayerDataByNameGeoJSON: Subscription;
  // $capas = [
  //   { label: 'Geocercas', checked: false, capaId: "" } /*"layer-geofencesPolygons" este es el id que trataba de poner para manipularla en el map helper*/
  // ];

  $capasService: Observable<any>;
  subscription_GetGeofenceIndicator: Subscription;
  suscription_GetCategoryListLayers: Subscription;
  subscription_GetCategoryList: Subscription;
  Subscription_GetMapMainSource: Subscription;

  constructor(
    private mapHelper: MapHelperService,
    public panelInternalLayerService: PanelInternalLayerService,
    public layerCatalogService: LayerService,
    public toolCarsSelectorService: ToolCarsSelectorService,
    private media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.$capasService = this.panelInternalLayerService.getLayers();
    this.subscription_GetGeofenceIndicator = this.$capasService.subscribe((data)=>{
      this.$capas = data;
    });
  }

  ngOnInit(): void {
    this.Subscription_GetMapMainSource = this.mapHelper.mainSource$.pipe(
      filter(location => location && location.isMainSourceReady && location.isStyleReady)
    ).subscribe(location => {
      if (location && location.isMainSourceReady && location.isStyleReady && !this.isInitializingLayers) {
        this.GetListLayers();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.suscription_GetListLayers)
      this.suscription_GetListLayers.unsubscribe();
      if (this.suscription_GetLayerDataByNameGeoJSON)
      this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
      if (this.suscription_GetCategoryListLayers)
        this.suscription_GetCategoryListLayers.unsubscribe();
      if (this.subscription_GetCategoryList)
        this.subscription_GetCategoryList.unsubscribe();
    if (this.subscription_GetGeofenceIndicator)
      this.subscription_GetGeofenceIndicator.unsubscribe();
    if (this.Subscription_GetMapMainSource)
      this.Subscription_GetMapMainSource.unsubscribe();
  }

  GetListLayers() {
    this.isInitializingLayers = true;
    if (this.suscription_GetListLayers)
      this.suscription_GetListLayers.unsubscribe();
    this.suscription_GetListLayers = this.layerCatalogService.GetListLayers(EnumLayerSources.Internal).subscribe(
      (data) => {
        this.$capas = data.result as LayerDTO[];
        this.panelInternalLayerService.capas = this.$capas;
        if (this.$capas.length > 0 && this.mobileQuery.matches) {
          this.layerCatalogService.isInternalLayersVisible = false;
        }
        this.$capas.forEach((element) => {
          console.log( "******************CAPA************ " + element.name + "_layer ******** icon: " + element.icon );
          this.panelInternalLayerService.createMapLayer(element);
        });
        this.GetCategories();
        this.isInitializingLayers = false;
      }
    );
  }

  GetCategories(){
    var categories = JSON.parse(localStorage.getItem("listaCategorias")) as LocationCategoryDTO[];
    var orderedCategories = categories.filter(lc=>{return !lc.itWorksAsGPS}) as LocationCategoryDTO[];
    this.hasVirtualCategories = orderedCategories.some((category) => category.itWorksAsVirtualLocation);
    this.hasGPSCategories = categories.some(category => category.itWorksAsGPS);
    orderedCategories.forEach((category) => {
      //crea objeto capa de categoria
      var layerDTO = new LayerDTO();
      layerDTO.name = category.shortName;
      layerDTO.icon = category.icon;
      layerDTO.idLayerType = category.itWorksAsCluster ? EnumLayerTypes.ClusterPoints : EnumLayerTypes.Point;
      layerDTO.atributeDisplay = category.DescriptionProperty != null ? category.DescriptionProperty : "_Id";
      layerDTO.categoryId = category.id;
      layerDTO.isVisible = true;
      layerDTO.checked = false;
      layerDTO.isLoading = false;
      layerDTO.itWorksAsVirtualLocation = category.itWorksAsVirtualLocation;
      
      //añade capa al array de capas
      this.$capas.push(layerDTO);
      this.panelInternalLayerService.capas = this.$capas;
      // crea el layer en el mapa y sus eventos
      this.panelInternalLayerService.createMapLayer(layerDTO);
      this.mapHelper.CreateCategoryLayerEvents(layerDTO);
      //si la categoria es de tipo default, se activa la capa
      if ( category.isDefaultLoaded)
        this.panelInternalLayerService.ActivateLayer(layerDTO);
    });
    if(!this.layerCatalogService.isExternalLayersVisible && !this.layerCatalogService.isMapLayersVisible)
      this.layerCatalogService.isInternalLayersVisible = true;
  }

  onClickListaCapas() {
    this.layerCatalogService.isExternalLayersVisible = false;
    this.layerCatalogService.isMapLayersVisible = false;
    this.toolCarsSelectorService.isCarSelectionToolVisible = false;
    this.layerCatalogService.isInternalLayersVisible = !this.layerCatalogService.isInternalLayersVisible;
  }

  //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  onToggleLayer(layer: LayerDTO) {
    this.panelInternalLayerService.onToggleLayer(layer); 
  }

  onToggleLayerActivos() {
    this.panelInternalLayerService.onToggleLayerActivos(!this.panelInternalLayerService.activeLayer.checked);
  }

  onToggleLayerFiltros() {
    this.panelInternalLayerService.onToggleLayerFiltros(!this.panelInternalLayerService.filterLayer.checked);
  }

  ClosePanel() {
    this.layerCatalogService.isInternalLayersVisible = false;
  }

  toggleInternalLayers(){
    this.panelInternalLayerService.isInternalLayersExpanded = !this.panelInternalLayerService.isInternalLayersExpanded;
  }

  toggleVirtualLayers(){
    this.panelInternalLayerService.isVirtualLayersExpanded = !this.panelInternalLayerService.isVirtualLayersExpanded;
  }

  onExpandCollapseStart(event: any) {
    this.panelInternalLayerService.isExpandCollapseAnimating = true;
  }

  onExpandCollapseDone(event: any) {
    this.panelInternalLayerService.isExpandCollapseAnimating = false;
  }
}
